import React from "react";
import { useSettings } from "@/context/SettingsContext";
import { useI18n } from "@/i18n";
import { MessageCircle } from "lucide-react";

export default function WhatsAppFab() {
  const { settings } = useSettings();
  const { t, lang } = useI18n();
  const wa = settings?.whatsapp || {};
  const number = (wa.contact_number || "").replace(/[^0-9]/g, "");
  if (!number) return null;
  const msg = encodeURIComponent(
    lang === "zh" ? wa.contact_message_zh || "你好" : wa.contact_message_en || "Hello"
  );
  const href = `https://wa.me/${number}?text=${msg}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label={t("common.whatsapp")}
      className="fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-3 text-white shadow-lg card-lift"
    >
      <MessageCircle className="h-5 w-5" />
      <span className="hidden sm:inline text-sm font-semibold">{t("common.whatsapp")}</span>
    </a>
  );
}
